"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ELEMENTS_BASE_URL = exports.DEFAULT_BASE_URL = exports.CLIENT_BASE_PATHS = exports.BT_TRACE_ID_HEADER = exports.API_KEY_HEADER = void 0;
const API_KEY_HEADER = 'X-API-KEY';
exports.API_KEY_HEADER = API_KEY_HEADER;
const BT_TRACE_ID_HEADER = 'bt-trace-id';
exports.BT_TRACE_ID_HEADER = BT_TRACE_ID_HEADER;
const DEFAULT_BASE_URL = `https://${"api.basistheory.com"}`;
exports.DEFAULT_BASE_URL = DEFAULT_BASE_URL;
const DEFAULT_ELEMENTS_BASE_URL = `https://${"elements.basistheory.com"}`;
exports.DEFAULT_ELEMENTS_BASE_URL = DEFAULT_ELEMENTS_BASE_URL;
const CLIENT_BASE_PATHS = {
  tokens: 'tokens',
  atomic: 'atomic',
  applications: 'applications',
  tenants: 'tenants/self',
  logs: 'logs',
  reactorFormulas: 'reactor-formulas',
  reactors: 'reactors',
  atomicBanks: 'atomic/banks',
  atomicCards: 'atomic/cards',
  permissions: 'permissions'
};
exports.CLIENT_BASE_PATHS = CLIENT_BASE_PATHS;